export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/dragging-icon.svg?01b80fe8718a374509a39e2116e31e8d";